<template>
  <div class="col s12 m4 l4">

        <div :id="'deleteevent-' + localEvent.uid" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons red-text text-darken-4 icon-modal-size">send</i>
          {{ translation('attention.modal.title') }}
        </h4>
        <p>{{ translation('delete.event.attenzione') }} {{ event.name }}</p>
         <p>{{ translation('msg.delete.event') }}</p>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModal()" class="modal-close btn-large my-cancel-btn">
          {{ translation('btn.annulla') }}
        </a>

        <a href="#!" @click="deleteEvent()" class="modal-close btn-large">
           {{ translation('btn.delete') }}
        </a>

      </div>
    </div>

    <div class="card margin-card">
      <div class="card-image">

          <img
              :src="`/ajax/proxy-image.php?url=${encodeURIComponent(event.path)}`"
              ref="eventImage"
              crossorigin="anonymous"
              @load="loadDominantColor"
            />

        <div class="card-title titolo-evento-box-lista" :style="colorBg()">{{ event.name }}</div>
        <div class="btn-floating-menu">
          <a class="btn-floating btn-large red" @click="toggleDropdown" ref="dropdownButton">
            <i class="material-icons basso">more_vert</i>
          </a>
        </div>
        <ul v-if="isDropdownOpen" class="dropdown-content-custom" ref="dropdownContent">
          <li><a href="#!" @click="openListParticipant(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">people</i></td>
                  <td> {{ translation('btn.link.menu.event.list.pax') }}</td>
                </tr>
              </table>
            </a></li>
          <li><a href="#!" @click="openEditEvents(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">mode_edit</i></td>
                  <td>{{ translation('btn.menu.event.modify') }}</td>
                </tr>
              </table>
            </a>
          </li>

          <li><a href="#!" @click="openEditCustomize(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">photo_library</i></td>
                  <td>{{ translation('title.customize.page') }}</td>
                </tr>
              </table>
            </a>
          </li>

          <li><a href="#!" @click="openEditLabel(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">text_fields</i></td>
                  <td>{{ translation('guest.list.fields.selection') }}</td>
                </tr>
              </table>
            </a>
          </li>

          <li v-if="hasTable"><a href="#!" @click="openEditManageTable(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">local_dining</i></td>
                  <td>{{ translation('event.card.title.gestione.tavoli') }}</td>
                </tr>
              </table>
            </a>
          </li>

             <li v-if="hasMail"><a href="#!" @click="openManageEmail(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">email</i></td>
                  <td>{{ translation('pagina.lista.mail.titolo') }}</td>
                </tr>
              </table>
            </a>
          </li>

          <li><a href="#!" @click="changeShow(event)">
              <table class="elenco-btn">
                <tr>
                  <td class="icon-list-menu"><i class="material-icons prefix">visibility</i></td>
                  <td>{{ translation('btn.link.menu.event.show.ipad') }}</td>
                </tr>
              </table>
            </a>
          </li>

           <li><a href="#!" @click="openModal()">
              <table class="elenco-btn" cell-padding="2" style="background-color: #c42634;border-radius: 10px;">
                <tr>
                  <td class="icon-list-menu" style="color: #fff;font-weight: bold;"><i class="material-icons prefix">delete_forever</i></td>
                  <td style="color: #fff;font-weight: bold;">{{ translation('btn.cancella.evento') }}</td>
                </tr>
              </table>
            </a>
          </li>

        </ul>
      </div>
      <div class="card-content">
        <table>
          <tr>
            <td class="td-width"><i class="material-icons prefix">pin_drop</i></td>
            <td>{{ localEvent.location }}</td>
          </tr>
          <tr>
            <td class="td-width"><i class="material-icons prefix">settings_applications</i></td>
            <td>{{ localEvent.event_type.name }}</td>
          </tr>

           <tr>
            <td class="td-width"><i class="material-icons prefix">people</i></td>
            <td>{{ localEvent.size_guest }}</td>
          </tr>
          <tr>
            <td class="td-width"><i class="material-icons prefix">today</i></td>
            <td>{{ formatDate(localEvent.event_date_start) }} - {{ formatDate(localEvent.event_date_finish) }}</td>
          </tr>
          <tr>
            <td class="td-width"><i class="material-icons prefix">settings_applications</i></td>
            <td>
              {{ translation('card.event.show.in.app') }}
                  <span class="event-hide" v-if="!active">{{ translation('option.no')
                }}</span>
                <span class="event-show" v-if="active">{{ translation('option.yes') }}</span></td>

          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import translationStore from '@/store/translations'
import eventSetting from '@/store/eventSettings.js'
import apiService from '@/services/apiService.js'
import loadingStore from '@/store/loading.js'
import useAuthStore from '@/store/authStore.js'
import eventBus from '@/plugins/eventBus'
import ColorThief from 'colorthief'
import M from 'materialize-css'

export default {
  name: 'CardEvent',
  data () {
    return {
      isDropdownOpen: false,
      translationStore: translationStore,
      eventSetting: eventSetting,
      authStore: useAuthStore,
      dominantColor: null, // 🔥 nuovo
      localEvent: { ...this.event },
      isDeleting: false
    }
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },

  computed: {
    fullEventData () {
      if (eventSetting && eventSetting.getters) {
        return eventSetting.getters.eventModel || {}
      }
      return {}
    },
    active () {
      return this.localEvent.active
    },
    translation () {
      return this.translationStore.getters.traduzione
    },
    hasMail () {
      return this.event.has_mailer
    },
    hasTable () {
      return this.event.has_table
    },
    userTimeFormat () {
      if (this.authStore && this.authStore.getters && this.authStore.getters.userInfo) {
        const userData = this.authStore.getters.userInfo
        if (userData.company_id && userData.company_id.country && userData.company_id.country.timezone && userData.company_id.country.timezone.time_format) {
          return userData.company_id.country.timezone.time_format
        }
      }
      return 'YYYY-MM-DD HH:mm:ss'
    }
  },
  watch: {
    'eventBus.state.latestOpenEventUid' (newUid) {
      if (newUid !== this.event.uid && this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    },
    event: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.localEvent = { ...newVal }
      }
    }
  },
  created () {
    this.eventBus = eventBus
  },
  methods: {

    openModal () {
      if (this.modal) {
        this.modal.open()
      }
    },

    closeModal () {
      if (this.modal) {
        this.modal.close()
      }
    },

    async deleteEvent () {
      loadingStore.commit('setLoading', true)
      const token = await apiService.getClientCredentialsToken()

      if (!token) {
        this.$router.push('/error')
        loadingStore.commit('setLoading', false)
        return
      }

      let url = process.env.VUE_APP_URL_EVENTS
      url += '/events/hard-delete/' + this.localEvent.uid
      const jsonRes = await apiService.sendRequestWithBearer('DELETE', url, token, null)

      loadingStore.commit('setLoading', false)

      if (!jsonRes) {
        this.$router.push('/error') // Gestione errore generica
      } else {
        if (jsonRes === 'ok') {
          // this.$router.push('/list-events')
          this.$emit('eventDeleted', this.localEvent.uid)
        } else {
          this.$router.push('/error') // Gestione errore generica
        }
      }

      this.closeModal()
    },

    async loadDominantColor () {
      const imgElement = this.$refs.eventImage
      if (!imgElement) return

      // Se l'immagine è già caricata e ha il proxy, proviamo direttamente
      if (imgElement.complete && imgElement.naturalWidth !== 0) {
        this.extractColor(imgElement)
      }
    },

    extractColor (img) {
      try {
        const colorThief = new ColorThief()
        // Importante: l'immagine DEVE avere crossOrigin = 'anonymous'
        // e il server deve supportarlo, altrimenti il canvas viene "macchiato" (tainted)
        const rgb = colorThief.getColor(img)
        this.dominantColor = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`
      } catch (e) {
        console.error('Errore ColorThief:', e)
        this.dominantColor = null
      }
    },

    getTextContrastColor (rgbString) {
      const [r, g, b] = rgbString.match(/\d+/g).map(Number)

      // luminanza percepita (W3C)
      const luminance = (0.299 * r) + (0.587 * g) + (0.114 * b)

      // soglia perfetta per UX (≈ 150)
      return luminance > 150 ? '#000000' : '#FFFFFF'
    },

    colorBg () {
      if (this.dominantColor) {
        const textContrastColor = this.getTextContrastColor(this.dominantColor)

        return `background: ${this.dominantColor}; color: ${textContrastColor};`
      }
      // fallback…
    },

    formatDate (dateString) {
      const format = this.fullEventData?.timezone?.time_format || 'YYYY-MM-DD'
      const tz = this.fullEventData?.timezone?.timezone_name || 'UTC'

      return this.$formatEventDate(dateString, format, tz)
    },

    async changeShow (event) {
      loadingStore.commit('setLoading', true)
      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return false
        }

        const uid = event.uid
        if (!uid) {
          this.$router.push('/error')
          return false
        }

        const url = process.env.VUE_APP_URL_EVENTS + '/events/show-in-app/' + uid
        const json = await apiService.sendRequestWithBearer('GET', url, token, null, null)

        if (json && json.res === 'ok' && typeof json.show_in_app === 'boolean') {
          this.localEvent.active = json.show_in_app
          this.toggleDropdown()
        }

        return true
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    async getGuests () {
      const url = process.env.VUE_APP_URL_EVENTS + '/guests/list-guests-all'
      try {
        const payload = { event_id: this.event.uid }
        const token = await apiService.getClientCredentialsToken()
        if (token) {
          const responseData = await apiService.sendRequestWithBearer('POST', url, token, payload)
          if (responseData && responseData.res === 'ok') {
            return responseData.guests
          }
        } else {
          this.$router.push('/error')
        }
      } catch (error) {
        this.errorMessage = null
        this.$router.push('/error')
      }
      return null
    },

    async setEventStorage (event) {
      await eventSetting.dispatch('resetEvents')
      const guests = await this.getGuests()
      await eventSetting.dispatch('setModel', event)
      eventSetting.dispatch('uploadGuests', guests)
      await eventSetting.dispatch('showHeaderChange', true)
    },

    async openListParticipant (event) {
      loadingStore.commit('setLoading', true)
      await this.setEventStorage(event)
      this.$router.push('/list-guests')
    },

    async openEditEvents (event) {
      await this.setEventStorage(event)
      this.$router.push('/modify-event')
    },

    async openEditLabel (event) {
      await this.setEventStorage(event)
      this.$router.push('/customize-label')
    },

    async openManageEmail (event) {
      await this.setEventStorage(event)
      this.$router.push('/list-email')
    },

    async openEditManageTable (event) {
      await this.setEventStorage(event)
      this.$router.push('/table-manager')
    },

    async openEditCustomize (event) {
      await this.setEventStorage(event)
      this.$router.push('/customize-event')
    },

    toggleDropdown () {
      this.isDropdownOpen = !this.isDropdownOpen
      if (this.isDropdownOpen) {
        eventBus.notifyOpen(this.event.uid)
      } else {
        eventBus.reset()
      }
    },
    handleClickOutside (event) {
      if (this.$refs.dropdownButton && this.$refs.dropdownContent) {
        if (this.isDropdownOpen &&
          !this.$refs.dropdownButton.contains(event.target) &&
          !this.$refs.dropdownContent.contains(event.target)) {
          this.isDropdownOpen = false
          eventBus.reset()
        }
      }
    }
  },
  mounted () {
    eventSetting.dispatch('showHeaderChange', false)
    document.addEventListener('click', this.handleClickOutside)

    const elemsModal = document.getElementById('deleteevent-' + this.localEvent.uid)

    this.modal = M.Modal.init(elemsModal, {
      onCloseEnd: () => { /* ... */ },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
    if (this.isDropdownOpen) {
      eventBus.reset()
    }
  }
}
</script>

<style scoped>
/* ------------------------------------------- */
/* Stili Generali e per Desktop (Large) */
/* ------------------------------------------- */

.margin-card {
  margin-right: 20px !important;
  margin-bottom: 20px;
}

.td-width {
  width: 15px;
  padding-right: 10px;
}

/* ------------------------------------------- */
/* Titolo Evento */
/* ------------------------------------------- */
.titolo-evento-box-lista {
  color: white;
  font-weight: 700;
  border-radius: 5px;
  padding: 5px 10px;
  position: absolute;
  bottom: 5%;
  left: 3%;
  opacity: 0.9;
  font-size: 1.2rem;
  max-width: 70%;
  margin: 0;
  z-index: 5;
  /* Aggiungi overflow hidden per i titoli troppo lunghi */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* ------------------------------------------- */
/* Bottone Menu a tendina */
/* ------------------------------------------- */
.btn-floating-menu {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.btn-floating-menu .btn-large {
  width: 45px;
  height: 45px;
  line-height: 45px;
}

/* Contenuto Dropdown Custom */
.dropdown-content-custom {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25); /* Ombra leggermente meno invasiva */
  z-index: 1000;
  min-width: 200px;
  list-style: none;
  padding: 5px 0;
  margin: 0;
  right: 5px; /* Lascia un piccolo margine dal bordo */
  top: 55px;
  border-radius: 5px;
}

.dropdown-content-custom li a {
  padding: 8px 10px;
  display: block;
  color: #333;
  text-decoration: none;
  font-size: 14px;
}

/* Tabelle nel dropdown */
.elenco-btn {
  width: 100%;
  border-collapse: collapse;
}

.elenco-btn > tr {
  border: none !important;
}

.elenco-btn > tr > td {
  padding: 0px !important;
}

.icon-list-menu {
  width: 30px !important;
  text-align: center;
}

/* Stili di stato */
.event-hide {
  color: red;
  font-weight: bold;
}
.event-show {
  color: green;
  font-weight: bold;
}

/* ------------------------------------------- */
/* 1. CORREZIONE LANDSCAPE: Sovrascrivi m4 per dispositivi stretti (colonna singola) */
/* Rende la card full-width (s12) sui dispositivi Landscape più stretti (fino a 768px) */
/* ------------------------------------------- */
@media only screen and (min-width: 601px) and (max-width: 768px) and (orientation: landscape) {
    /* Targetta specificamente telefoni in orizzontale o tablet molto stretti */

    .col.m4 {
        /* Forza la card a occupare l'intera riga su schermi m stretti in landscape */
        width: 100% !important;
        margin-left: auto !important;
        left: auto !important;
        right: auto !important;
    }

    .margin-card {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .titolo-evento-box-lista {
        font-size: 1.1rem;
        max-width: 80%; /* Più spazio, essendo colonna singola */
    }

    .dropdown-content-custom {
        min-width: 250px; /* Più spazio disponibile, può essere più largo */
        right: 5px; /* Assicura che sia all'interno della card */
    }
}

/* ------------------------------------------- */
/* 2. Ottimizzazioni per Mobile Portrait (schermi <= 600px) */
/* ------------------------------------------- */
@media only screen and (max-width: 600px) {
  .margin-card {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 15px;
  }

  .titolo-evento-box-lista {
    font-size: 0.9rem; /* Ulteriore riduzione per prevenire accavallamenti */
    max-width: 85%;
    bottom: 3%;
    left: 3%;
  }

  .btn-floating-menu {
    top: 5px;
    right: 5px;
  }

  .btn-floating-menu .btn-large {
    width: 40px;
    height: 40px;
    line-height: 40px;
  }

  .dropdown-content-custom {
    min-width: 180px;
    right: 5px; /* Margine dal bordo */
    top: 45px;
  }

  .dropdown-content-custom li a {
    font-size: 13px;
    padding: 6px 8px;
  }

  .card-content table {
    font-size: 0.8rem; /* Contenuto ancora più piccolo */
  }
}
.basso{
      line-height: 47px!important;
}
</style>
